// General
export const CLIENT_HOST: string = 'https://admin.gold-race.org';
export const SERVER_HOST = 'https://server.gold-race.org';
export const API: string = '/api';

// Routes
export const AUTH: string = '/auth';
export const TRANSLATIONS: string = '/translations';
export const VOLUNTEERS: string = '/volunteers';
export const EMAILS: string = '/emails';
export const LOGS: string = '/logs';

/**
 * Controllers
 */
// Auth route
export const CHECK_JWT_ENDPOINT: string = API + AUTH + '/check-JWT';
export const SIGN_IN_USER_ENDPOINT: string = API + AUTH + '/sign-in-user';
export const SEND_VERIFICATION_CODE_ENDPOINT: string =
  API + AUTH + '/send-verification-code';

// Translations route
export const TRANSLATIONS_ENDPOINT: string = API + TRANSLATIONS;

// Volunteers route
export const VOLUNTEERS_ENDPOINT: string = API + VOLUNTEERS;
export const ASSIGN_VOLUNTEER_ENDPOINT: (volunteerID: string) => string = (
  volunteerID
) => API + VOLUNTEERS + `/${volunteerID}` + '/assign-volunteer';
export const COMMENTS_ENDPOINT: (
  volunteerID: string,
  commentID: string
) => string = (volunteerID, commentID = '') =>
  API + VOLUNTEERS + `/${volunteerID}` + '/comments' + `/${commentID}`;

// Logs route
export const LOGS_ENDPOINT: string = API + LOGS;
export const AUTH_LOGS_ENDPOINT: string = LOGS_ENDPOINT + '/auth';
